import { fadeInLeft, fadeInRight } from "react-animations";
import styled, { keyframes, css } from "styled-components";
import Color from "../../assets/styles/colors";

const fadeInLeftAnimation = keyframes`${fadeInLeft}`;
const fadeInRightAnimation = keyframes`${fadeInRight}`;

export const AddToCart = styled.button`
  padding: 0;
  width: 25px;
  height: 25px;
  cursor: pointer;
  font-size: 12px;
  text-align: center;
  font-size: 0.75rem;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  border-radius: 999px;
  will-change: transform;
  -webkit-transition: transform 0.4s cubic-bezier(0.19, 1, 0.22, 1);
  -moz-transition: transform 0.4s cubic-bezier(0.19, 1, 0.22, 1);
  -o-transition: transform 0.4s cubic-bezier(0.19, 1, 0.22, 1);
  transition: transform 0.4s cubic-bezier(0.19, 1, 0.22, 1);
  border: 1px solid
    ${(props) =>
      props.theme.isDarkTheme
        ? Color.textColorBlackSeven
        : Color.colorBlueCard};
  color: ${(props) =>
    props.theme.isDarkTheme ? Color.textColorBlackSeven : Color.colorBlueCard};

  animation: ${(props) =>
    props.quantity
      ? css`
          ${fadeInLeftAnimation} 0.5s ease-in-out
        `
      : css`
          ${fadeInRightAnimation} 0.5s ease-in-out
        `};

  margin-left: ${(props) => (props.quantity ? "10px" : 0)};

  :hover {
    color: ${(props) =>
      props.theme.isDarkTheme
        ? Color.textColorBlackSeven
        : Color.colorBlueCard};
  }
`;

export const AddToCartIcon = styled.i`
  vertical-align: middle;
`;

export const OffToCart = styled.button`
  padding: 0;
  width: 25px;
  height: 25px;
  cursor: pointer;
  font-size: 12px;
  text-align: center;
  font-size: 0.75rem;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  border-radius: 999px;
  will-change: transform;
  -webkit-transition: transform 0.4s cubic-bezier(0.19, 1, 0.22, 1);
  -moz-transition: transform 0.4s cubic-bezier(0.19, 1, 0.22, 1);
  -o-transition: transform 0.4s cubic-bezier(0.19, 1, 0.22, 1);
  transition: transform 0.4s cubic-bezier(0.19, 1, 0.22, 1);
  border: 1px solid
    ${(props) =>
      props.theme.isDarkTheme
        ? Color.textColorBlackSeven
        : Color.colorBlueCard};
  color: ${(props) =>
    props.theme.isDarkTheme ? Color.textColorBlackSeven : Color.colorBlueCard};

  display: ${(props) => (props.quantity <= 0 ? "none" : "inline-block")};

  :hover {
    color: ${(props) =>
      props.theme.isDarkTheme
        ? Color.textColorBlackSeven
        : Color.colorBlueCard};
  }
`;

export const OffToCartIcon = styled.i`
  vertical-align: middle;
`;

export const QuantityNum = styled.span`
  padding-left: 8px;
  color: ${(props) =>
    props.theme.isDarkTheme ? Color.textColorBlackSeven : Color.colorBlueCard};
`;
